<template>
    <div class="dropdown-button">
        <a :class="buttonClass" class="dropdown-button__button" @click.prevent="toggle" href="#">
            <slot name="button"></slot>
        </a>
        <div class="dropdown-button__list-container" v-show="open">
            <slot name="options"></slot>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'DropdownButton',
        props: {
            buttonClass: String
        },
        data () {
            return {
                open: false
            };
        },
        methods: {
            toggle () { this.open = !this.open }
        }
    }
</script>